export const get_unit_order = `query get_unit_order($id: String!){
    get_unit_order(id: $id){
        transaction_code
        status
        direction
        account
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        count
        fulfilled_count
        last_available_net_price
        validity_start
        validity_end
        deal_price
        purchase_value
    }
}`;
